
import { defineComponent, PropType } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'CatalogFilters',
  props: {
    visible: { type: Boolean as PropType<boolean>, default: false },
    filterColor: { type: String as PropType<string>, default: '' },
    filterWidth: { type: String as PropType<string>, default: '' },
    filterStones: { type: String as PropType<string>, default: '' },
  },
  setup(_, { emit }) {
    const emitSetFilter = (type: string, value: string) => emit('set-filter', type, value)
    return { emitSetFilter }
  },
})
